const Dates = {
  dateFormat: 'MMM d, y',
  dateTimeFormat: 'MMM d, y HH:mm',
};

export default Dates;
